import { LogEntryWithType, CallLog } from '@/types/TInbox';

/**
 * Checks if a call log is "empty", meaning only the AI has spoken
 * and a human user has not responded in the transcript.
 * For all other log types (text, voicemail), it returns false.
 */
export const isConversationEmpty = (log: LogEntryWithType): boolean => {
	if (log.type === 'call') {
		const callLog = log.originalLog as CallLog;
		if (!callLog.transcript) {
			return true;
		}

		const userHasSpoken = /(\n|^)user@/m.test(callLog.transcript);

		return !userHasSpoken;
	}

	return false;
};
